<div class="dialog">
  <app-product-list
    [stacked]="true"
    [GroupPriority]="this.data.GroupPriority"
    [products]="this.data.products"
    [selectedProductId]="this.data.selectedProductId"
    (emitProductSelect)="selectProduct($event)"
  ></app-product-list>
</div>
